import React, { useEffect, useState, useRef } from "react";
import styles from "./SubCotizacionDetailsInfo.module.scss";
import { motion } from "framer-motion";
import ButtonsProject from "../../UI/ButtonsProject/ButtonsProject";
import SubQuotationPostulation from "./subCotizacionPostulante/SubQuotationPostulation";
import { ReactComponent as Edit } from "../../../assets/svg/editarSkill.svg"
import { ReactComponent as Delete } from "../../../assets/svg/description-sub.svg"
import { ReactComponent as Subir } from "../../../assets/svg/presupuesto.svg";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { deleteSubQuotation, openMainModal, updateSubCotizacion } from "../../../store/actions/profileActions";

const SubCotizacionDetailsInfo = ({
  isPostulation,
  isProject,
  allowOpen,
  dropdownOpen,
  setDropdownOpen,
  deleteSubQuotation,
  updateSubCotizacion,
  openMainModal,
  fromPage,
  displayInfo,
  item,
  isPostulating,
  status,
  onClick,
  name,
  ownData,
  id,
  type,
  isAllowed,
  setPreparePostulation,
  quotation_payroll,
  ...props
}) => {
  const history = useHistory()
  const [open, setOpen] = useState(false)
  const [isEditing, setIsEditing] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [description , setDescription] = useState(item.description);
  const [saveChanges, setSaveChanges] = useState(false);
  const [isEditingSubQuotation, setIsEditingSubQuotation] = useState(false);
  
  
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const fileInputRef = useRef(null);

  const handleUpdateButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  //Definimos si el usuario puede editar o no
  const userFullName = ownData.type === "COMPANY" ? ownData.razon_social : ownData.name + " " + ownData.last_name;  
  const isMyQuotations = history.location.pathname === (`/comunidad-edify/${ownData.id}/${userFullName}`);

useEffect(() => {
    if (isMyQuotations) {
      setIsEditing(true);
    }
  }, [history.location.pathname]);

//Mejoramos la visualizacion del nombre del archivo
const removeSpecialCharacters = (nombreExcel) => {
  const sanitizedFileName = nombreExcel.split('/').pop().replace(/[^\w\s.-]/g, '');
  return sanitizedFileName;
}

//Maneja el borrado de subcotizaciones
  const deleteSubQuotationHandler = () => {
    openMainModal({
      title: "¿Estás seguro de que quieres eliminar esta rubro?",
      body: "Una vez eliminado, no podrás recuperarlo",
      isSuccess: false,
      confirmHandler: () => {
        deleteSubQuotation(item.id)
        setDropdownOpen(false)
      },
    })
  }

  
  

  //Manejamos el estado del boton de guardar cambios
  useEffect(() => {
    if (item.description !== description ||
      selectedFile !== null) {
        setSaveChanges(true)
    } else {
      setSaveChanges(false)
    }
  }, [description, selectedFile, item])

  //Maneja la edicion de subQuotations
  const editHandler = () => {
    setIsEditingSubQuotation(!isEditingSubQuotation);
    setSelectedFile(null);
    setSaveChanges(false);
    setDescription(item.description);
  };

  //Maneja el guardado de cambios
  const handleSaveChanges = () => {
    const editedDescription = description;
    const editedFile = selectedFile;
    const editedId = item.id;
    const editedName = item.name;

    const editedSubQuotation = {
      description: editedDescription,
      file: editedFile,
      id: editedId,
      name: editedName,
    };

    updateSubCotizacion(editedSubQuotation)
    setIsEditingSubQuotation(false)
    setSaveChanges(false)
    setSelectedFile(null)
  }



  return (
    <>
      <div className={!allowOpen ? styles.infoContainer : styles.infoContainerOpened}>
        <div className={`${styles.itemInfo_container} ${allowOpen ? styles.opened : ""}`}>
          <div className={`${allowOpen ? styles.opened : ""} ${styles.itemInfo}`} onClick={!isEditing ? () => { setDropdownOpen(true); setPreparePostulation(true) } : null}>
            <h4 className={styles.rubro}>{name || "No hay titulo"}</h4>
            {isEditing && allowOpen ? (
              <div className={`${styles.iconContainer} ${open ? styles.iconContainer_openEditText : ""}`}>
                <div className={styles.editContainer} onClick={() => editHandler()}>
                  <p>{!isEditingSubQuotation ? "editar" : "descartar cambios"}</p>
                  <div className={`${styles.iconEdit} ${open ? styles.iconEdit_open : ""}`} >
                    <Edit />
                  </div>
                </div>
                <div className={styles.borderIconDelete} onClick={(e) => {
                  e.stopPropagation();
                  deleteSubQuotationHandler()
                }}>
                  <p>eliminar</p>
                  <div className={`${styles.iconDelete} ${open ? styles.iconDelete_open : ""}`}  >
                    <Delete />
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        {allowOpen ? (
          <motion.div
            initial={{ height: "0px", opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
          >
            {isEditingSubQuotation ? (
                   <div style={{ padding: 10 }} className={styles.subDescription}> 
                    <textarea
                      className={styles.subDescription_edit}
                      value={description === "undefined" ? "" : description}
                      onChange={(e) => {
                        setDescription(e.target.value)
                      }}
                    />
                    </div>
                  ) : (
                    <>
                    <div className={styles.subDescription_textContainer}>
                      <p className={styles.subDescription_text}>{description === "undefined" ? "No hay descripción" : description}</p>
                    </div>
                    </>
                  )}
            <div
              className={`${styles.itemInfo_container} ${allowOpen ? styles.opened : ""
                }`}
            >
              {!fromPage ? (     
                <>
                  {isEditing &&
                    <div className={styles.fileInput}>
                      <h4 className={styles.fileInput_header}>Planilla de presupuesto</h4>
                      <input
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                        className={styles.fileInput_excel}
                        ref={fileInputRef}
                      />
                      <div className={styles.fileInput_buttonContainer}>
                        {!isEditingSubQuotation && (
                        <p className={styles.fileInput_placeHolder}>Archivo actual: {selectedFile !== null
                          ? selectedFile.name.length > 50
                            ? selectedFile.name.slice(0, 50) + "..."
                            : selectedFile.name
                          : removeSpecialCharacters(item.quotation_payroll).length > 50
                            ? ( <span title={removeSpecialCharacters(item.quotation_payroll)}>{removeSpecialCharacters(item.quotation_payroll).slice(0, 50) + "..."}</span>)
                            : ( <span title={removeSpecialCharacters(item.quotation_payroll)}>{removeSpecialCharacters(item.quotation_payroll)}</span>
                            )}</p>
                        )}
                        {isEditingSubQuotation && (
                        <button className={styles.fileInput_button} onClick={handleUpdateButtonClick}>
                          <Subir />
                          Actualizar
                        </button>
                        )}
                      </div>
                    </div>
                  }
                </>
              ) : (
                <div
                  className={`${styles.rubrosContainer} ${fromPage && styles.fromPage
                    }`}
                >

                </div>
              )}
              
              {type === "subquotation" && props.userId === props.userData.id ? (
                <SubQuotationPostulation id={id} item={item} />
              ) : (
                <span>
                  <ButtonsProject
                    subproyecto={item}
                    type={type}
                    onClick={onClick}
                    isPostulating={isPostulating || status === "SEND"}
                    isAllowed={isAllowed}
                  />
                </span>
              )}
              {saveChanges && isEditing && (
                <div className={styles.saveChangesContainer}>
                  <button className={styles.saveChangesContainer_button} onClick={handleSaveChanges}>Guardar cambios</button>
                 </div>
              )}
                  
            </div>
          </motion.div>
        ) : null}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    ownData: state.general.userData,
  }

}

export default connect(mapStateToProps, { deleteSubQuotation, openMainModal, updateSubCotizacion })(SubCotizacionDetailsInfo);  